import { labelOnly } from "./label-only";
import type { ToolActivity } from "./tool-activity";
import type { ToolActivityState } from "./tool-activity-state";

/** Picks the failed, running or done sentence; the browser tools answer a failure
 * as TEXT, so only `hasFailed` separates "Clicked" from "Could not click". */
export function stateLabel(
  state: ToolActivityState,
  labels: { failed: string; running: string; done: string },
): ToolActivity {
  if (state.hasFailed) return labelOnly(labels.failed);
  return labelOnly(state.isRunning ? labels.running : labels.done);
}
